import { render, staticRenderFns } from "./TopNavbarDashboard.vue?vue&type=template&id=8561ed36&"
import script from "./TopNavbarDashboard.vue?vue&type=script&lang=js&"
export * from "./TopNavbarDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TopNavbarDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TopNavbarDashboard.vue"
export default component.exports